import React from "react";
// import HeroSlider from "../components/HeroSlider";
// import AboutSection from "../components/AboutSection";
import ServicesGrid from "../components/ServicesGrid";
import BlogList from "../components/BlogList";
import Testimonials from "../components/Testimonials";
import Footer from "../components/Footer";
import KeciorenIntro from "../components/ServiceRegions/İntros/KeciorenIntro";
import DynamicImage from "../components/DynamicImage";


const Home = () => {
  return (
    <> 
    <div>
        
      {/* <HeroSlider /> */}
      {/* <AboutSection/> */}
       <DynamicImage />
      <KeciorenIntro/>
      <ServicesGrid />
      <BlogList/>
      <Testimonials/>
      <Footer/>
     
    </div>
     </>
  );
};

export default Home;
